
import React, { createContext, useContext, useState, ReactNode } from 'react';

type Language = 'en' | 'fr';

interface TranslationContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const translations = {
  en: {
    // Buildings page
    'buildings.title': 'Building Management',
    'buildings.subtitle': 'Control all electrical systems in your buildings',
    'buildings.globalControls': 'Global Controls - All Buildings',
    'buildings.buildingControls': 'Building Controls',
    'buildings.apartments': 'Apartments',
    'buildings.occupied': 'Occupied',
    'buildings.vacant': 'Vacant',
    'buildings.apartmentsOccupied': 'apartments occupied',
    // Device controls
    'devices.airConditioning': 'A/C',
    'devices.lighting': 'Lighting',
    'devices.electronics': 'Electronics',
    'devices.appliances': 'Appliances',
    'devices.power': 'Power',
    // Status
    'status.on': 'ON',
    'status.off': 'OFF',
  },
  fr: {
    // Buildings page
    'buildings.title': 'Gestion des Bâtiments',
    'buildings.subtitle': 'Contrôlez tous les systèmes électriques de vos bâtiments',
    'buildings.globalControls': 'Contrôles Globaux - Tous les Bâtiments',
    'buildings.buildingControls': 'Contrôles du Bâtiment',
    'buildings.apartments': 'Appartements',
    'buildings.occupied': 'Occupé',
    'buildings.vacant': 'Vacant',
    'buildings.apartmentsOccupied': 'appartements occupés',
    // Device controls
    'devices.airConditioning': 'Clim.',
    'devices.lighting': 'Éclairage',
    'devices.electronics': 'Électronique',
    'devices.appliances': 'Appareils',
    'devices.power': 'Alimentation',
    // Status
    'status.on': 'MARCHE',
    'status.off': 'ARRÊT',
  }
};

const TranslationContext = createContext<TranslationContextType | undefined>(undefined);

export const TranslationProvider = ({ children }: { children: ReactNode }) => {
  const [language, setLanguage] = useState<Language>('en');

  const t = (key: string): string => {
    return translations[language][key] || key;
  };

  return (
    <TranslationContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (context === undefined) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  return context;
};
